import { GatewayAuthentication, GatewayContact } from "@conformite/gateway";
import ChevronLeftIcon from "@endya-conformite/ui-kit/src/assets/icons/chevron-left.svg?react";
import {
  Sidebar,
  SidebarDelimiter,
  SidebarLink,
  SidebarSubtitle,
} from "@endya-conformite/ui-kit";
import { useIsAllowed } from "@src/session/useIsAllowed";
import { useMe } from "@src/store/store.me";
import style from "./ParametreSidebar.module.scss";

export function ParametreSidebar() {
  const { hasAllowedRole, hasAllowedCognitoRole } = useIsAllowed();
  const { me } = useMe();

  return (
    <Sidebar
      hasRoleEndya={hasAllowedCognitoRole(GatewayAuthentication.Role.ENDYA)}
      prenom={me?.contact.prenom}
      nom={me?.contact.nom}
    >
      <SidebarLink to="/" precise>
        <div className={style.backHomeLink}>
          <ChevronLeftIcon className={style.backHomeLinkIcon} />
          Retour à l&apos;accueil
        </div>
      </SidebarLink>

      <SidebarDelimiter />
      <SidebarSubtitle>Paramètres</SidebarSubtitle>

      <SidebarLink to="/parametres/informations-personnelles">
        Mes informations
      </SidebarLink>

      {hasAllowedRole(GatewayContact.ContactRoleUtilisateur.ADMINISTRATEUR) && (
        <SidebarLink to="/parametres/informations-societe">
          Ma société
        </SidebarLink>
      )}

      {hasAllowedRole(
        GatewayContact.ContactRoleUtilisateur.ADMINISTRATEUR,
        GatewayContact.ContactRoleUtilisateur.RESPONSABLE_CONFORMITE
      ) && (
        <SidebarLink to="/parametres/gestion-utilisateurs">
          Gestion des utilisateurs
        </SidebarLink>
      )}

      {hasAllowedRole(GatewayContact.ContactRoleUtilisateur.ADMINISTRATEUR) && (
        <SidebarLink to="/parametres/factures">Mes factures</SidebarLink>
      )}

      <SidebarLink to="/parametres/identifiants">
        Identifiants de connexion
      </SidebarLink>

      {hasAllowedRole(GatewayContact.ContactRoleUtilisateur.ADMINISTRATEUR) && (
        <SidebarLink to="/parametres/securite">Sécurité</SidebarLink>
      )}
    </Sidebar>
  );
}
